<template>
	<ui-input
		:value="value"
		label="PIN"
		:pattern="/^[0-9#*]+$/"
		pattern-error="Invalid PIN (only numbers, # and *)"
		@input="$emit('input', $event)"
	>
		<template slot="inlineIcon">
			<ui-menu
				icon="fal fa-hourglass-start fa-2x"
				tooltip="PIN delay"
			>
				<ui-menu-item
					v-for="item in pinDelayList"
					:key="item"
					:icon="item === pinDelay ? 'fal fa-check' : ''"
					:label="`${item} seconds`"
					@click="$emit('update:pinDelay', item)"
				/>
			</ui-menu>
		</template>
	</ui-input>
</template>

<script>
import UiInput from "lib/components/ui/Input";
import UiMenu from "lib/components/ui/Menu";
import UiMenuItem from "lib/components/ui/MenuItem";

export default {
	name: "PinInput",
	components: {
		UiInput,
		UiMenu,
		UiMenuItem
	},
	props: {
		pinDelay: {
			type: Number,
			default: 5,
			required: false
		},
		value: {
			type: String,
			default: null,
			required: false
		}
	},
	data() {
		return {
			pinDelayList: [1, 2, 3, 4, 5, 8, 10, 15, 20, 25, 30, 40, 50, 60]
		};
	}
};
</script>
